import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaMobileAlt } from 'react-icons/fa';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const response = location.state?.response;
  
  useEffect(() => {
    //console/log('Payment Success Page loaded with response:', response);
    
    // If no response data, redirect to snacks page
    if (!response) {
      navigate('/snacks');
    }
    
    // Auto redirect after 30 seconds
    const timer = setTimeout(() => {
      navigate('/snacks');
    }, 30000);
    
    return () => clearTimeout(timer);
  }, [navigate, response]);
  
  const handleContinue = () => {
    navigate('/snacks');
  };
  
  if (!response) return null;
  
  return (
    <>
      <Header searchQuery={''} setSearchQuery={() => {}} toggleCart={null} />
      
      <div className="payment-success-page">
        <div className="success-container">
          <div className="success-header">
            <FaCheckCircle className="success-icon" />
            <h2>Payment Initiated</h2>
          </div>
          
          <div className="success-body">
            <p className="response-message">{response.message}</p>
            
            <div className="mpesa-instructions">
              <FaMobileAlt className="mobile-icon" />
              <p>Check your phone for the M-PESA prompt and enter your PIN to complete the payment.</p>
              {response.request_id && (
                <p className="request-id">Request ID: {response.request_id}</p>
              )}
            </div>
          </div>
          
          <button className="success-btn" onClick={handleContinue}>
            Continue Shopping
          </button>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default PaymentSuccessPage;
